<script>
import SignInForm from '../../form/myAccount/SignInForm';
import LoginDropdown from '@phoenix/mixins/components/myAccount/nav/LoginDropdown';

export default {
  components: { SignInForm },

  mixins: [LoginDropdown],
};
</script>

<template>
  <div>
    <sign-in-form
      :redirect-url="links.redirectUrl"
      :should-display-submit-button="true"
      :should-show-error-in-toast="false"
      data-cy="navbar-my-account-login"
    >
      <template #legend>
        <h2 class="h6">{{ $t('MyAccount.alreadyRegistered') }}</h2>
      </template>
    </sign-in-form>

    <hr class="divider divider--md" />

    <h2 class="h6">{{ $t('MyAccount.orCreateANewOne') }}</h2>

    <div class="text-muted text-small mt-sm">{{ $t('MyAccount.orCreateANewOneText') }}</div>

    <a :href="links.accountCreate" type="button" class="btn btn--secondary mt-base">
      <span class="btn__text">{{ $t('MyAccount.createMyAccount') }}</span>
    </a>
  </div>
</template>
